import { MenuItem, MenuSection } from 'core/api/menu/menu.types';

export const getMenuItemById = ({
  menuItemId,
  menuSections,
}: {
  menuItemId: string;
  menuSections: MenuSection[];
}): MenuItem => {
  const numericItemId = Number(menuItemId);
  const selectedSection = menuSections.find((s) =>
    s.MenuItems.find((item) => item.MenuItemId === numericItemId),
  );
  const selectedItem = selectedSection?.MenuItems?.find(
    (item) => item.MenuItemId === numericItemId,
  );
  return selectedItem;
};
